/* Juradem lookbook motion — tiny IntersectionObserver class-stamper.
   Passive: stamps .is-in once per element, no per-scroll-frame work.
   The hidden pre-reveal state only exists under html.jrlb-js, which the
   template's inline gate adds when motion is allowed — so this script's
   only job is stamping reveals. */
(function () {
  var root = document.querySelector('.jrlb');
  if (!root) return;
  var els = [].slice.call(root.querySelectorAll('.jrlb-rv'));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || !document.documentElement.classList.contains('jrlb-js')) {
    els.forEach(function (e) { e.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
  els.forEach(function (e) { io.observe(e); });
})();
